// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FireTwoToneSvg from "@fishx/icons-svg/es/asn/FireTwoTone";
import FishxIcon from '../components/FishxIcon';

var FireTwoTone = function FireTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FireTwoToneSvg
  }));
};

FireTwoTone.displayName = 'FireTwoTone';
export default React.forwardRef(FireTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FireTwoTone.js
// module id = 2784
// module chunks = 0